import axios from "axios";
const instance = axios.create({
    baseURL : "https://api.morpho.jewelry"
    // baseURL : "http://localhost:4444"
})
instance.interceptors.request.use((config) => {
config.headers.Authorization = window.localStorage.getItem("token");
return config;
})

export default instance;